import axios from 'src/utils/httpClients/axios';

import { WORKFLOW_API } from 'src/config';
import {
  WorkflowDefinitionDto,
  CreateWorkflowDefinitionDto,
  UpdateWorkflowDefinitionDto,
  WorkflowDefinitionSummaryDto,
  WorkflowDefinitionVersionDto,
} from 'src/@types/workflow/types';

const baseUrl = `${WORKFLOW_API.domain}api/v1/workflow-definitions`;

export async function getWorkflowDefinitions(
  signal?: AbortSignal
): Promise<WorkflowDefinitionSummaryDto[]> {
  const response = await axios.get<WorkflowDefinitionSummaryDto[]>(baseUrl, { signal });

  return response.data;
}

export async function getWorkflowDefinition(
  definitionNumber: number
): Promise<WorkflowDefinitionDto> {
  const response = await axios.get<WorkflowDefinitionDto>(`${baseUrl}/${definitionNumber}`);

  return response.data;
}

export async function getWorkflowDefinitionVersions(
  definitionNumber: number,
  signal?: AbortSignal
): Promise<WorkflowDefinitionVersionDto[]> {
  const response = await axios.get<WorkflowDefinitionVersionDto[]>(
    `${baseUrl}/${definitionNumber}/versions`,
    {
      signal,
    }
  );

  return response.data;
}

export async function createWorkflowDefinition(
  dto: CreateWorkflowDefinitionDto
): Promise<WorkflowDefinitionDto> {
  const response = await axios.post<WorkflowDefinitionDto>(baseUrl, dto);

  return response.data;
}

export async function updateWorkflowDefinition(
  definitionNumber: number,
  dto: UpdateWorkflowDefinitionDto
): Promise<WorkflowDefinitionDto> {
  const response = await axios.put<WorkflowDefinitionDto>(`${baseUrl}/${definitionNumber}`, dto);

  return response.data;
}

export async function setWorkflowDefinitionActive(
  definitionNumber: number,
  isActive: boolean
): Promise<WorkflowDefinitionDto> {
  const response = await axios.patch<WorkflowDefinitionDto>(`${baseUrl}/${definitionNumber}`, {
    isActive,
  });

  return response.data;
}

export async function deleteWorkflowDefinition(definitionNumber: number): Promise<void> {
  await axios.delete(`${baseUrl}/${definitionNumber}`);
}
